var loadFaqList_gql_default = `
query GetFaqCategories($filter: MpMageplazaFaqsCategoryFilterInput, $pageSize: Int, $currentPage: Int) {
  MpMageplazaFaqsCategoryList(filter: $filter, pageSize: $pageSize, currentPage: $currentPage) {
    items {
      name
      icon
      articles(pageSize: 100, filter: { visibility: { eq: "1" } }){
        items {
          article_content
          name
        }
      }
    }
  }
}
`;
export {
  loadFaqList_gql_default as default
};
